// for add employee

export const RESET_LOGO = "reset_logo";
export const LOGO = "logo";
export const LOGO_SUCCESS = "logo_success";
export const LOGO_FAILURE = "logo_failure";
